import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'dashboard',
  'create-appointment-req',
  [],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dashboard',
  type: 'post',
  slug: ['appointments'],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/create-appointment-req.js